const enum PayrollIntegration {
  // This list should be aligned with
  // backend/components/payroll_integrations/base/app/public/payroll_integrations/base/integration.rb

  // Exports
  a3nom = 'a3nom',
  zucchetti = 'zucchetti',
  sage100 = 'sage100',
  paierh = 'paierh',
  yeapPaierh = 'yeap_paierh',
  silae = 'silae',
  datev = 'datev',
  gispaghe = 'gispaghe',

  // Api
  a3innuva = 'a3innuva',
  datevApi = 'datev_api',
  datevLugApi = 'datev_lug_api',
  datevLauds = 'datev_lauds',
}
export type PayrollIntegrationType = (typeof PayrollIntegration)[keyof typeof PayrollIntegration]

export default PayrollIntegration
